
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import AgPassword from "@/components/ag-form/components/ag-passwod.vue";
import Multiselect from "@vueform/multiselect";
import api from "@/api/index";

export default defineComponent({
  name: "ag-form",
  components: {
    AgPassword,
    Multiselect,
  },
  setup() {
    const { t, locale } = useI18n();
    return { t, locale };
  },
  props: {
    options: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    companies: [],
  }),
  mounted() {
    this.getCompanies();
  },
  methods: {
    async getCompanies() {
      const res = await api.companies.get();
      this.companies = res.data.entityData;
    },
  },
});
